/**
 * Copyright (c) ProductiveHub, Inc. All Rights Reserved.
 *
 *
 * @summary
 * @author Andrew McCrink <andrew@emagid.com.com>
 *
 * Created: 01/12/2022
 */
import { useAnalytics } from "@popped/popshap-kiosk-components";
import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import Popup from "../components/Popup";
import { Holder } from "./Holder";

import "./index.scss"

export const IdleTimeoutContext =
  React.createContext<
    | {
      showHomepageScreensaver: boolean;
      clearTimeouts: () => void;
      setTimeouts: (millis?: number) => void;
      showInactive: boolean;
      count: number;

    }
    | undefined
  >(undefined);

export const IdleTimeoutProvider = ({ children, timeoutCallback, logEvent, popup }: any) => {
  const [timeoutTime, setTimeoutTime] = useState(120000); //120000 = 2 mins

  const [showHomepageScreensaver, setShowHomepageScreensaver] =
    useState<boolean>(false);
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null)
  const countdown = useRef<ReturnType<typeof setTimeout> | null>(null)
  const [showInactive, setShowInactive] = useState(false);
  const [count, setCount] = useState(10);
  let homepageScreensaverTimeout: any = false;

  useEffect(() => {
    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];
    const analytics = [
      "load",
      "click",
    ];



    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }


    setTimeouts();
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
        clearTimeouts();
      }

    }
  }, [popup]);





  const updateCountdown = useCallback((_refreshTime: number) => {
    const remainingTime = (_refreshTime - Date.now());
    if (remainingTime < (10 * 1000) && remainingTime > (0)) {
      popup && setShowInactive(true);
      setCount(Math.ceil(remainingTime / 1000))
    } else {
      setShowInactive(false);
      setCount(0)
    }
    countdown.current = setTimeout(() => {
      updateCountdown(_refreshTime)
    }, 1 * 1000)
  }, [popup, timeout.current])




  const clearTimeouts = useCallback(() => {

    if (countdown.current) clearInterval(countdown.current)
    if (timeout.current) clearTimeout(timeout.current);
    if (homepageScreensaverTimeout) clearTimeout(homepageScreensaverTimeout);
    setTimeout(() => {
      setShowHomepageScreensaver(false);
    }, 200);
  }, [homepageScreensaverTimeout]);

  const goHome = useCallback(() => {
    //Nav to Screensaver page or HomePage
    //navigate("/");
    console.log("goHome", Date.now())
    setShowInactive(false);
    logEvent('system', "timeout")
    timeoutCallback?.();
  }, [logEvent, timeoutCallback]);

  const setTimeouts = useCallback((millis?: number) => {
    timeout.current = setTimeout(goHome, millis ?? timeoutTime);
    const _refreshTime = (Date.now() + (millis ?? timeoutTime))
    console.log("Refresh Time", Date.now() + (millis ?? timeoutTime))

    updateCountdown(_refreshTime);


  }, [goHome, timeoutTime, updateCountdown]);

  const resetTimeout = useCallback(() => {
    clearTimeouts();
    setTimeouts();
  }, [clearTimeouts, setTimeouts]);



  return (
    <IdleTimeoutContext.Provider value={{
      setTimeouts,
      clearTimeouts,
      showHomepageScreensaver,
      showInactive,
      count,
    }}>
      {children}
      <Popup
        showPopup={showInactive}
        setShowPopup={setShowInactive}
        customHolder={true}>
        <>
          <Holder>
            <></>
          </Holder>
          <h3>{count}</h3>
        </>

      </Popup>
    </IdleTimeoutContext.Provider>
  );
};

export const useIdleTimer = () => useContext(IdleTimeoutContext);
